<template>
  <BreadCrumb PageTitle="Les nouveaux clients" />
  <NewCustomers />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import NewCustomers from "../../components/Customers/NewCustomers.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "NewCustomersPage",
  components: {
    BreadCrumb,
    NewCustomers,
  },

   
});
</script>